// Package imports:
import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import Bugsnag from "@bugsnag/js";
// Service imports:
import { isSSN, stripSSN } from "../../../services/utils";
import { GET_KELDAN_API_URL } from "../../../services/config";
// Type imports:
import { EditContactFormValues } from "../../../types/DueDiligenceTypes";

export const FormObserver: React.FC = () => {
    const { values, initialValues, setFieldValue } = useFormikContext<EditContactFormValues>();
    const [lastCheckedSSN, setLastCheckedSSN] = useState<string | null>(initialValues.ssn);

    const fetchIndividualBySSN = async (ssn: string | null): Promise<{ firstname: string, lastname: string } | null> => {
        if (ssn === null) return null;
        
        try {
            const cleanedSSN = stripSSN(ssn);
            const url = `${GET_KELDAN_API_URL()}/DueDiligence/SearchIndividual?ssn=${cleanedSSN}`;

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (!response.ok) {
                throw new Error("Failed to fetch individual data");
            }

            const data: {firstname: string, lastname: string} = await response.json();
            return data;
        } catch (error) {
            console.error("Error fetching individual data:", error);
            return null;
        }
    }
    
    useEffect(() => {
        const handleSSNChange = async () => {
            const ssn = values.ssn;
            if (values.stopIndividualSearch || ssn === lastCheckedSSN || !isSSN(ssn)) {
                return;
            }

            setLastCheckedSSN(ssn);

            if (!values.alien) {
                try {
                    const parsedFieldData = await fetchIndividualBySSN(ssn);
                    if (parsedFieldData?.firstname && parsedFieldData.lastname) {
                        setFieldValue("name", `${parsedFieldData.firstname} ${parsedFieldData.lastname}`);
                    }
                } catch (e) {
                    if (e instanceof Error) Bugsnag.notify(e);
                }
            }
        }

        handleSSNChange();
    }, [values.ssn, lastCheckedSSN, setFieldValue]);

    return null;
}